/* eslint-disable no-unused-expressions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
import CN from 'classnames';
import { Button } from 'components/atoms';
import { motion } from 'framer-motion';
import React, { FC, ReactNode } from 'react';

interface ModalProps {
  [x: string]: any;
  children?: ReactNode | string | number | undefined;
  className?: string | undefined;
  customWidth?: string | undefined;
  customZIndex?: number | undefined;
  footerButtonAlignment?: 'left' | 'right' | 'center' | 'between';
  footerAlignment?: string | undefined;
  headerTitle?: string;
  isActive?: boolean | undefined;
  isCustomStyles?: boolean;
  isFooterShow?: boolean;
  isHeaderShow?: boolean;
  isSeparator?: boolean;
  onClickPrimaryBtn?: () => void | undefined;
  onClickSecondaryBtn?: () => void | undefined;
  onHeaderCloseButtonClick?: () => void | undefined;
  onOverlayClick?: () => void | undefined;
  primaryButtonTitle?: string;
  secondaryButtonTitle?: string | ReactNode;
  size?: 'sm' | 'md' | 'lg';
  modalContainerClassName?: string | undefined;
  headerTitleClassName?: string | undefined;
}

export const Modal: FC<ModalProps> = ({
  children,
  className,
  customWidth,
  customZIndex,
  footerButtonAlignment,
  footerAlignment,
  headerTitle,
  isActive,
  isCustomStyles,
  isFooterShow,
  isHeaderShow,
  isSeparator,
  onClickPrimaryBtn,
  onClickSecondaryBtn,
  onHeaderCloseButtonClick,
  onOverlayClick,
  primaryButtonTitle,
  secondaryButtonTitle,
  size,
  modalContainerClassName,
  headerTitleClassName,
  ...restProps
}: ModalProps) => {
  const OverlayClassName = !isCustomStyles
    ? CN(
        'modal-overlay fixed flex top-0 bottom-0 left-0 right-0 justify-center items-center h-full bg-black bg-opacity-80',
        className,
        {
          hidden: !isActive,
        },
        {
          'z-50': customZIndex === undefined,
          'z-10': customZIndex === 10,
          'z-20': customZIndex === 20,
          'z-30': customZIndex === 30,
          'z-40': customZIndex === 40,
          'z-60': customZIndex === 60,
          'z-70': customZIndex === 70,
          'z-80': customZIndex === 80,
          'z-90': customZIndex === 90,
          'z-100': customZIndex === 100,
        },
      )
    : className;

  /** main modal container styles */
  const ModalContainerClassName = CN(
    'modal-container flex flex-col justify-between items-center h-auto bg-white shadow-lg rounded',
    customWidth === undefined && {
      'w-[400px]': size === 'sm',
      'w-[600px]': size === 'md',
      'w-[800px]': size === 'lg',
    },
    modalContainerClassName,
  );

  /** main modal header styles */
  const ModalHeaderClassName = CN('modal-Header flex w-full justify-between pl-6 py-[17px] pr-6', {
    'border-b-[1px] border-[#E5E7EB]': isSeparator,
  });

  /** prevent modal hide when click inside modal */
  const disableOverlayClick = (event: any) => {
    event.stopPropagation();
  };

  return (
    <div
      className={OverlayClassName}
      onClick={(e: any) => {
        e.stopPropagation();
        e.preventDefault();
        if (onOverlayClick) {
          onOverlayClick();
        }
      }}
      {...restProps.overlayProps}
    >
      {/* Modal main container  */}
      <motion.div
        animate={isActive ? 'open' : 'closed'}
        variants={{
          open: { opacity: 1, y: 0, transition: { duration: 0.1 } },
          closed: { opacity: 1, y: '-100%' },
        }}
        className={ModalContainerClassName}
        style={customWidth && { width: customWidth }}
        {...restProps.modalProps}
        onClick={(e: any) => disableOverlayClick(e)}
      >
        {/* Modal Header  */}

        {isHeaderShow && (
          <div className={ModalHeaderClassName} {...restProps.headerProps}>
            <span
              className={CN(
                'header-title flex justify-center items-center text-[16px] font-medium text-gray-800',
                headerTitleClassName,
              )}
            >
              {headerTitle}
            </span>

            <i
              className="ri-close-fill w-3 flex justify-center items-center cursor-pointer"
              {...restProps.headerCloseButtonProps}
              onClick={(e: any) => {
                e.stopPropagation();
                e.preventDefault();
                onHeaderCloseButtonClick && onHeaderCloseButtonClick();
              }}
            />
          </div>
        )}

        {/* Modal body */}
        {children}

        {/* Modal footer */}
        {isFooterShow && (
          <div
            className={CN(
              'modal-footer flex w-full py-2 pl-6 px-4 bg-gray-50 items-center rounded-b-md',
              {
                'justify-start': footerButtonAlignment === 'left',
                'justify-end': footerButtonAlignment === 'right',
                'justify-center': footerButtonAlignment === 'center',
                'justify-between': footerButtonAlignment === 'between',
                'flex-col-reverse': footerAlignment === 'horizontal',
              },
            )}
            {...restProps.footerProps}
          >
            {/* footer primary button */}

            {/* footer secondary button */}
            {secondaryButtonTitle !== '' && (
              <Button
                appearance="primary"
                className="mr-2"
                size="sm"
                isRounded
                onClick={() => {
                  onClickSecondaryBtn && onClickSecondaryBtn();
                }}
                {...restProps.secondaryButtonProps}
              >
                {secondaryButtonTitle}
              </Button>
            )}

            {primaryButtonTitle !== '' && (
              <Button
                appearance="secondary"
                size="sm"
                isRounded
                onClick={() => {
                  onClickPrimaryBtn && onClickPrimaryBtn();
                }}
                {...restProps.primaryButtonProps}
              >
                {primaryButtonTitle}
              </Button>
            )}
          </div>
        )}
      </motion.div>
    </div>
  );
};

export default Modal;

Modal.defaultProps = {
  children: undefined,
  className: undefined,
  customWidth: undefined,
  customZIndex: undefined,
  footerButtonAlignment: 'left',
  headerTitle: 'Lorem ipsum',
  isActive: true,
  isCustomStyles: false,
  isFooterShow: true,
  isHeaderShow: true,
  isSeparator: true,
  onClickPrimaryBtn: undefined,
  onClickSecondaryBtn: undefined,
  onHeaderCloseButtonClick: undefined,
  onOverlayClick: undefined,
  primaryButtonTitle: 'Lorem',
  secondaryButtonTitle: 'Lorem',
  footerAlignment: undefined,
  size: 'sm',
  modalContainerClassName: undefined,
  headerTitleClassName: undefined,
};
